const state = {

    selectedTax:null,
    isCountryTax:false ,
    lsHotels:null,

}
const getters = {


    GET_SELECTED_TAX: (state) => {

        return state.selectedTax
    }
 ,
    GET_IS_COUNTRY_TAX:(state)=>{

        return state.isCountryTax
    },
     GET_ALL_HOTELS:(state)=>{
         return state.lsHotels

     }
}


const actions = {

    SET_SELECTED_TAX: ({ commit }, obj) => {

        commit('saveSelectedTax', obj)
    },

    SET_IS_COUNTRY_TAX:({commit},val)=>{
        commit('saveIsCountry',val)
    },


    SET_ALL_HOTELS:({commit},val)=>{
      commit('saveHotels',val)
    },

    CLEAR_TAX_STORE: ({ commit }) => {
        commit('clearStore')
    }
}


const mutations = {

    clearStore: (state) => {
        state.selectedTax = null
        state.isCountryTax=false
        state.lsHotels=null
    },
    saveHotels:(state,val)=>{
           state.lsHotels=val 
    },

    saveSelectedTax: (state, val) => {
        state.selectedTax = val
    },
    saveIsCountry:(state,val)=>{
        state.isCountryTax=val
    }

}




export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}